import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Company } from '../interfaces/company';
import { environment } from 'src/environments/environment';
import { CompanyRelation } from '../enums/company-relation';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {
  constructor(private http: HttpClient) { }

  /**
   * Get the company table
   *
   * @param companyId ID of the requested company
   * @param relation Get company only with the IDs (default) or also the related table informations
   *
   * @returns The company information
   */
  getCompanyById(companyId: string, relation = CompanyRelation.NONE): Observable<Company> {

    //lookup in cache
    //get EmployeeWithRelations
    
    return this.http.get<Company>(
      `${environment.url}/bucket/${environment.buckets.company}/data/${companyId}?relation=${relation}`
    );
  }

  /**
   * Get all companies. Be aware that this requested can contain a lot of data!
   *
   * @returns The all available companies
   */
  getAllCompanies() {
    return this.http.get<Company[]>(
      `${environment.url}/bucket/${environment.buckets.company}/data/`
    );
  }

  updateCompany(company: Company): Observable<Company> {
    let flat = this.flatCompany(company);
    return this.http.put<Company>(`${environment.url}/bucket/${environment.buckets.company}/data/${company._id}`, flat);
  }

  flatCompany(company) {
    // TODO: COMPANY FLACH MACHEN

    // COUNTRY
    if (company.country) {
      if (typeof company.country !== "string")
        company.country = company.country._id;
    }
    // CATEGORY
    if (company.category) {
      if (typeof company.category !== "string")
        company.category = company.category._id;
    }
    // TARGES
    if (company.targets) {
      if (typeof company.targets !== "string") {
          company.targets = company.targets._id
      }
    }
    // OPENING HOURS
    if (company.opening_hours) {
      if (typeof company.opening_hours !== "string") {
        company.opening_hours = company.opening_hours._id
      }
    }
    // SERVICES[]
    if (company.services) {
      if (typeof company.services[0] != "string") {
        for (let i = 0; i < company.services.length; i++) {
          company.services[i] = company.services[i]._id
        }
      }
    }
    return company;
  }
}
